// extracted by mini-css-extract-plugin
export var loadingSpinner = "_53-1";
export var standaloneTable = "_53-0";